import { FieldTypes } from 'models/MetaInfo/MetaSearchRequest';

export const searchDimensionsFieldTypes: FieldTypes[] = [
    'DIMENSION',
    'CUSTOM_DIMENSION',
    'MEASUREMENT',
    'CUSTOM_MEASUREMENT',
];
